import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { nightsBetween } from "@/components/experience/BudgetCalculator";

const toIso = (d) => (d ? format(d, "yyyy-MM-dd") : "");
const fromIso = (s) => (s ? parseISO(s) : undefined);

export const DateRangeField = ({ start, end, onChange, optional }) => {
  const [open, setOpen] = useState(false);
  const range = { from: fromIso(start), to: fromIso(end) };
  const nights = nightsBetween(start, end);
  const label = range.from
    ? `${format(range.from, "EEE d MMM yyyy")}${range.to ? ` – ${format(range.to, "EEE d MMM yyyy")}` : " – choose end date"}`
    : "Choose dates";
  return (
    <div>
      <p className="field-label">Dates {optional && <span className="font-normal text-muted-foreground">(optional)</span>}</p>
      <div className="flex flex-wrap items-center gap-3">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <button type="button" className="field flex min-w-[280px] max-w-full items-center gap-3 text-left" data-testid="exp-dates-button">
              <CalendarDays className="h-4 w-4 shrink-0 text-primary" /><span className={range.from ? "" : "text-muted-foreground"}>{label}</span>
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-auto border-border bg-card p-0" align="start" data-testid="exp-dates-popover">
            <Calendar mode="range" numberOfMonths={2} defaultMonth={range.from || new Date()} selected={range}
              disabled={{ before: new Date() }} weekStartsOn={1}
              onSelect={(r) => { onChange(toIso(r?.from), toIso(r?.to)); if (r?.from && r?.to && r.from.getTime() !== r.to.getTime()) setOpen(false); }} />
          </PopoverContent>
        </Popover>
        {nights > 0 && <span className="text-sm text-muted-foreground" data-testid="exp-dates-nights">{nights} night{nights === 1 ? "" : "s"}</span>}
        {start && <button type="button" className="btn-link inline-flex items-center gap-1 text-sm" onClick={() => onChange("", "")} data-testid="exp-dates-clear"><X className="h-3.5 w-3.5" /> Clear</button>}
      </div>
    </div>
  );
};
